<button
  class="tertiary-btn delete-cart"
  type="button"
  aria-haspopup="true"
  aria-expanded="false"
  (click)="deleteCartModal()"
  [class.disabled]="showSrp"
  [disabled]="showSrp"
>
  <mat-icon svgIcon="deletecart" class="delete-cart" [class.disabled]="showSrp"></mat-icon>
  @if (deviceDetectorService.isDesktop()) {
  <span class="delete-menu-button" [innerHtml]="'cart.deleteAll' | cxTranslate"></span>
  }
</button>
